import { http, HttpResponse } from 'msw';
import { PlessService } from '../../app/shared/pless-service.model';
import { ResponseUtils } from './response-utils';

export const kymw47Handlers = [
    // マルチコード一覧取得 /kymw47/getMultiCodeList
    http.post(PlessService.SERVICE.getMultiCodeList.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.getMultiCodeList.url, req);
        return HttpResponse.json(getMultiCodeListResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // マルチ商品情報取得 /kymw47/getMultiGoods
    http.post(PlessService.SERVICE.getMultiGoods.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.getMultiGoods.url, req);
        return HttpResponse.json(getMultiGoodsResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // マルチコード情報取得 /kymw47/getMultiCodeInfo
    http.post(PlessService.SERVICE.getMultiCodeInfo.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.getMultiCodeInfo.url, req);
        return HttpResponse.json(getMultiCodeInfoResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // 候補商品情報取得 /kymw47/getCandidateGoods
    http.post(PlessService.SERVICE.getCandidateGoods.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.getCandidateGoods.url, req);
        return HttpResponse.json(getCandidateGoodsResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // マルチ商品情報登録 /kymw47/registMultiGoods
    http.post(PlessService.SERVICE.registMultiGoods.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.registMultiGoods.url, req);
        return HttpResponse.json(registMultiGoodsResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
    // マルチ商品情報削除 /kymw47/deleteMultiGoods
    http.post(PlessService.SERVICE.deleteMultiGoods.url, async ({ request }) => {
        const req = await request.json();
        console.log(PlessService.SERVICE.deleteMultiGoods.url, req);
        return HttpResponse.json(deleteMultiGoodsResponse);
        // return ResponseUtils.getSysError();
        // return ResponseUtils.getE0100();
        // return ResponseUtils.get500();
    }),
];

const getMultiCodeListResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            TotalNum: '100',
            StartDispNum: '1',
            EndDispNum: '75',
            MultiCodeList: [
                {
                    MultiCode: 'M0000001',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000002',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000003',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000004',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000005',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000006',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000007',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000008',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000009',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000010',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000011',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000012',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000013',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000014',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000015',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000016',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000017',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000018',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000019',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000020',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000021',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000022',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000023',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000024',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000025',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000026',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000027',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000028',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000029',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000030',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000031',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000032',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000033',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000034',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000035',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000036',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000037',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000038',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000039',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000040',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000041',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000042',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000043',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000044',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000045',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000046',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000047',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000048',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000049',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000050',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000051',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000052',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000053',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000054',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000055',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000056',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000057',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000058',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000059',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000060',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000061',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000062',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000063',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000064',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000065',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000066',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000067',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000068',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000069',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000070',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000071',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000072',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000073',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000074',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
                {
                    MultiCode: 'M0000075',
                    GuideGoodsName: '商品案内用規格名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名'
                },
            ]
        },
    },
};

const getMultiGoodsResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            MultiGoodsList: [
                {
                    MultiCode: 'M0000001',
                    CommonCatchcopy: '共通キャッチコピー',
                    CommonGoodsExplanation: '共通商品説明',
                    PublishSeq: 1,
                    PCode: 'P0000001',
                    ApplyTermEnd: '',
                    GuideGoodsName: '商品名１',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/01/01'
                },
                {
                    MultiCode: 'M0000001',
                    CommonCatchcopy: '共通キャッチコピー',
                    CommonGoodsExplanation: '共通商品説明',
                    PublishSeq: 2,
                    PCode: 'P0000002',
                    ApplyTermEnd: '20241220',
                    GuideGoodsName: '商品名２',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/04/12'
                },
                {
                    MultiCode: 'M0000001',
                    CommonCatchcopy: '共通キャッチコピー',
                    CommonGoodsExplanation: '共通商品説明',
                    PublishSeq: 3,
                    PCode: 'P0000003',
                    ApplyTermEnd: '',
                    GuideGoodsName: '商品名３',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/05/10'
                },
                {
                    MultiCode: 'M0000001',
                    CommonCatchcopy: '共通キャッチコピー',
                    CommonGoodsExplanation: '共通商品説明',
                    PublishSeq: 4,
                    PCode: 'P0000004',
                    ApplyTermEnd: '',
                    GuideGoodsName: '商品名４',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/08/19'
                },
                {
                    MultiCode: 'M0000001',
                    CommonCatchcopy: '共通キャッチコピー',
                    CommonGoodsExplanation: '共通商品説明',
                    PublishSeq: 5,
                    PCode: 'P0000005',
                    ApplyTermEnd: '',
                    GuideGoodsName: '商品名５',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/11/24'
                },
            ]
        },
    },
};

const getMultiCodeInfoResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            MultiCode: 'M0000001',
            CommonCatchcopy: '共通キャッチコピー(追加)',
            CommonGoodsExplanation: '共通商品説明(追加)'
        },
    },
};
const getCandidateGoodsResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            CandidateGoodsList: [
                {
                    MultiCode: '',
                    PublishSeq: 1,
                    PCode: 'P0000001',
                    ApplyTermEnd: '',
                    GuideGoodsName: 'Pコード同一商品',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/11/24'
                },
                {
                    MultiCode: '',
                    PublishSeq: 2,
                    PCode: 'P1000001',
                    ApplyTermEnd: '',
                    GuideGoodsName: 'Pコード不一致商品',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/08/19'
                },
                {
                    MultiCode: '',
                    PublishSeq: 3,
                    PCode: 'P1000002',
                    ApplyTermEnd: '20240810',
                    GuideGoodsName: '商品名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/05/10'
                },
                {
                    MultiCode: 'M0000001',
                    PublishSeq: 4,
                    PCode: 'P0000001',
                    ApplyTermEnd: '',
                    GuideGoodsName: 'Pコード同一商品２',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/11/24'
                },
                {
                    MultiCode: 'M0000001',
                    PublishSeq: 1,
                    PCode: 'P1000003',
                    ApplyTermEnd: '',
                    GuideGoodsName: 'Pコード不一致商品２',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/11/24'
                },
                {
                    MultiCode: 'M0000001',
                    PublishSeq: 3,
                    PCode: 'P1000004',
                    ApplyTermEnd: '',
                    GuideGoodsName: 'Pコード不一致商品３',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/11/24'
                },
                {
                    MultiCode: 'M0000001',
                    PublishSeq: 5,
                    PCode: 'P1000005',
                    ApplyTermEnd: '',
                    GuideGoodsName: 'Pコード不一致商品４',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/11/24'
                },
                {
                    MultiCode: 'M0000002',
                    PublishSeq: 6,
                    PCode: 'P0000001',
                    ApplyTermEnd: '20241031',
                    GuideGoodsName: 'Pコード同一商品３',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/04/12'
                },
                {
                    MultiCode: 'M0000002',
                    PublishSeq: 7,
                    PCode: 'P1000006',
                    ApplyTermEnd: '',
                    GuideGoodsName: 'Pコード不一致商品５',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/01/01'
                },
            ]
        },
    },
};
const registMultiGoodsResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
        obj: {
            MultiGoodsList: [
                {
                    MultiCode: 'M9999999',
                    CommonCatchcopy: '共通キャッチコピー',
                    CommonGoodsExplanation: '共通商品説明',
                    PublishSeq: 1,
                    PCode: 'P9999999',
                    ApplyTermEnd: '20241031',
                    GuideGoodsName: '商品名',
                    GuideStandardName: '規格名',
                    MakerName: 'メーカー名',
                    PayeeClient: '取引先コード:取引先名',
                    RegistDate: '2024/01/01'
                },
            ]
        },
    },
};
const deleteMultiGoodsResponse = {
    status: 'ok',
    message: '処理完了',
};